import styled from "styled-components";

export const Container = styled.div`
  margin: 0 0 10px;
  padding: 0 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h2`
  padding: 0 12px;
  font-family: Open Sans;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
  text-transform: uppercase;
`;

export const Line = styled.div`
  flex: 1;
  height: 1px;
  background: #c5cee0;
`;
